import {Injectable} from "@angular/core";
import {LocalStorageService} from "../Storage/LocalStorageService";
import {GlobalService} from "../GlobalService";
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as moment from "moment";
import { Observable } from "rxjs";

@Injectable()
export class UserService implements NPS.Common.Authorization.IUserService {
    
    static userKey = "user";
    private _user: NPS.Common.IUser;
    private subject = new BehaviorSubject(null);

    constructor(
        private globalService: GlobalService,
        private localStorageService: LocalStorageService) {
        this._user = this.localStorageService.get<NPS.Common.IUser>(UserService.userKey);
        if(this._user)
        {
            this.subject.next(this._user);
        }
    }

    getUserSubject(): Observable<any> {
        return this.subject.asObservable();
    }

    get user() {
        return this._user;
    }

    set user(user: NPS.Common.IUser) {
        this._user = user;
        if (user !== null) {
            this.localStorageService.set(UserService.userKey, user);
        }
        else {
            this.localStorageService.remove(UserService.userKey);
        }
        this.subject.next(this._user);
    }

    clearUser() {
        this.user = null;
        this.localStorageService.storage.clear();
    }

    isAccessTokenExpired(user: NPS.Common.IUser): boolean {
        return moment.utc() > moment.utc(user.expires);
    }
}


// WEBPACK FOOTER //
// ./~/@nordpoolgroup/nps-angular-2-common/src/Authorization/UserService.ts